import { navigateTo } from '@max/meituan-uni-navigate';
import { getPlatformType, isMiniProgramOrWebview, PlatformType } from '@nibfe/mkt-env-api';
export default function navigateToPage(link, dealId, channelId) {
    const platformType = getPlatformType();
    const isInMTApp = platformType === PlatformType.mtApp || platformType === PlatformType.mtAppWebView;
    const isInDPApp = platformType === PlatformType.dpApp || platformType === PlatformType.dpAppWebView;
    if (channelId) {
        // 交行app里有channelId，跳h5落地页
        let url = `https://i.meituan.com/awp/h5/lvyou/deal/ticket/detail/index.html?dealId=${dealId}&channelId=${channelId}`;
        window.location.href = url;
        return;
    }
    if (isMiniProgramOrWebview() && platformType === PlatformType.mtHotelMinaWebview) {
        navigateTo({
            url: `/pages/navigator/index?appId=wxde8ac0a21135c07d&path=${encodeURIComponent(link)}`,
            _web: {
                miniProgramNative: true
            }
        });
    }
    else {
        // 站外环境唤起美团app
        if (!isInDPApp && !isInMTApp && !isMiniProgramOrWebview() && !link.startsWith('http')) {
            navigateTo({
                url: `https://w.dianping.com/cube/evoke/meituan.html?url=${encodeURIComponent(link)}`,
                _web: {
                    miniProgramNative: true
                }
            });
        }
        // 小程序 / 站内 直接跳转落地页。
        else {
            navigateTo({
                url: link,
                _web: {
                    miniProgramNative: true
                }
            });
        }
    }
}
